import { CommentEntityBuilder } from "@/modules/social/tests/commentEntity.builder"
import { ReactionSocialPostEntityBuilder } from "@/modules/social/tests/reactionSocialPostEntity.builder"
import { SocialPostEntityBuilder } from "@/modules/social/tests/socialPostEntity.builder"
import type { CommentDto, ReactionDto, SocialPostDto } from "@/modules/social/gateway/socialDto"

export const SOCIAL_TEST_USER = {
  id: "user-1",
  username: "johndoe",
  firstname: "John",
  lastname: "Doe",
  avatar: null,
}

export const SOCIAL_TEST_USER_2 = {
  id: "user-2",
  username: "janedoe",
  firstname: "Jane",
  lastname: "Doe",
  avatar: null,
}

export const SOCIAL_TEST_USER_3 = {
  id: "user-3",
  username: "coach_mike",
  firstname: "Mike",
  lastname: "Coach",
  avatar: null,
}

/* ── Social Posts ── */

// Session post: 3 reaction types, current user reacted with ❤️, 4 comments
export const SESSION_POST_RICH: SocialPostDto = SocialPostEntityBuilder.create()
  .withId("post-session-rich")
  .withComments(4)
  .withReactions(
    ReactionSocialPostEntityBuilder.create()
      .withMyReaction("❤️")
      .withGroupedReactions([
        { emoji: "❤️", number: 5 },
        { emoji: "💪", number: 3 },
        { emoji: "👊", number: 1 },
      ])
      .buildDto(),
  )
  .buildDto()

// Exercise post: current user has 💪, 2 reaction types
export const EXERCISE_POST_RICH: SocialPostDto = SocialPostEntityBuilder.create()
  .withId("post-exercise-rich")
  .withComments(2)
  .withReactions(
    ReactionSocialPostEntityBuilder.create()
      .withMyReaction("💪")
      .withGroupedReactions([
        { emoji: "💪", number: 2 },
        { emoji: "😱", number: 1 },
      ])
      .buildDto(),
  )
  .buildDto()

// Bare defaults
export const SESSION_POST_DEFAULT: SocialPostDto = SocialPostEntityBuilder.create().withId("post-session-1").buildDto()

export const EXERCISE_POST_DEFAULT: SocialPostDto = SocialPostEntityBuilder.create()
  .withId("post-exercise-1")
  .buildDto()

/* ── Comments ── */

// Comment with @mention and ❤️ reactions
export const COMMENT_WITH_MENTION: CommentDto = CommentEntityBuilder.create()
  .withId("comment-1")
  .withUser(SOCIAL_TEST_USER)
  .withText("@coach_mike Great session today!")
  .withMentions([{ username: "coach_mike", userId: "user-3", startAt: 0, length: 10 }])
  .withReactions(
    ReactionSocialPostEntityBuilder.create()
      .withGroupedReactions([{ emoji: "❤️", number: 2 }])
      .buildDto(),
  )
  .withCreationDate("2025-01-20T11:00:00.000Z")
  .buildDto()

// Comment with 1 reply and current user has reacted with ❤️
export const COMMENT_WITH_REPLY: CommentDto = CommentEntityBuilder.create()
  .withId("comment-2")
  .withUser(SOCIAL_TEST_USER_2)
  .withText("Amazing work everyone 💪")
  .withReactions(
    ReactionSocialPostEntityBuilder.create()
      .withMyReaction("❤️")
      .withGroupedReactions([
        { emoji: "❤️", number: 3 },
        { emoji: "💪", number: 1 },
      ])
      .buildDto(),
  )
  .withChildrenCount(1)
  .withCreationDate("2025-01-20T11:30:00.000Z")
  .buildDto()

// Reply to COMMENT_WITH_REPLY
export const COMMENT_REPLY: CommentDto = CommentEntityBuilder.create()
  .withId("comment-3")
  .withUser(SOCIAL_TEST_USER_3)
  .withText("Totally agree! Best WOD of the week")
  .withParentCommentId("comment-2")
  .withCreationDate("2025-01-20T11:45:00.000Z")
  .buildDto()

// Comment by current user (can delete in UI)
export const COMMENT_BY_CURRENT_USER: CommentDto = CommentEntityBuilder.create()
  .withId("comment-4")
  .withUser(SOCIAL_TEST_USER)
  .withText("See you all next week!")
  .withCreationDate("2025-01-20T12:00:00.000Z")
  .buildDto()

export const COMMENT_DEFAULT: CommentDto = CommentEntityBuilder.create()
  .withId("comment-default")
  .withUser(SOCIAL_TEST_USER)
  .withText("Great session!")
  .withCreationDate("2025-01-20T11:00:00.000Z")
  .buildDto()

export const REACTION_DEFAULT: ReactionDto = {
  emoji: "❤️",
  user: SOCIAL_TEST_USER,
  creationDate: "2025-01-20T11:00:00.000Z",
}

export const SOCIAL_TEST_DATA = {
  SESSION_POST: {
    DEFAULT: SESSION_POST_DEFAULT,
    RICH: SESSION_POST_RICH,
  },
  EXERCISE_POST: {
    DEFAULT: EXERCISE_POST_DEFAULT,
    RICH: EXERCISE_POST_RICH,
  },
  COMMENT: {
    DEFAULT: COMMENT_DEFAULT,
    WITH_MENTION: COMMENT_WITH_MENTION,
    WITH_REPLY: COMMENT_WITH_REPLY,
    REPLY: COMMENT_REPLY,
    BY_CURRENT_USER: COMMENT_BY_CURRENT_USER,
  },
  REACTION: {
    DEFAULT: REACTION_DEFAULT,
  },
}
